import { callAPI, HTTPMethod } from './API'
import { ProjectListParams } from '../model/Project'
import { ProjectViewListParams, ProjectViews } from '../model/ProjectView'

const getBaseApi = (tenantId: string, projectId: string) =>
    `/tenants/${tenantId}/projects/${projectId}/views`

const getParams = (params: ProjectViewListParams) => {
    return {
        page: params?.page?.toString() ?? '',
        offset: params?.offset?.toString() ?? '',
        search: params.search ?? '',
        stage: params.stage ?? '',
    }
}

export async function listProjectViews(
    tenantId: string,
    stageId: string,
    params: ProjectListParams
): Promise<ProjectViews> {
    return await callAPI(getBaseApi(tenantId, stageId), {
        method: HTTPMethod.GET,
        query: getParams(params),
    })
}
